import useRequest from "~/composables/use-request";
import { ORDER, SORT } from "~/constants";
import { formatPaginatedResponseItems, formatRequestOptions, formatTeam } from "./format";

const TeamsAPI = {
  load(options?: IRequestPaginatedOptions & { identityId?: string }): Promise<IPaginatedResponse<IModelIdentityItem>> {
    const { request } = useRequest();
    const params: IRequestPaginatedParams & { filters?: IRequestParamFilter } = formatRequestOptions(options);

    if (options?.identityId) {
      if (params.filters)
        params.filters["identities.type"] = options?.identityId;
      else
        params.filters = { "identities.type": options?.identityId };
    }

    params.order = ORDER.asc;
    params.sort = SORT.title;

    return request
      .post<IPaginatedResponse<IResponseTeam>>("/api/team/list", { body: params })
      .then(response => formatPaginatedResponseItems(response, formatTeam));
  },

  loadById(teamId: string): Promise<IModelIdentityItem> {
    const { request } = useRequest();

    return request
      .get<IContentResponse<IResponseTeam>>(`/api/team/get_by_id/id/${teamId}`)
      .then(async (response) => {
        return formatTeam(response.content);
      });
  },
};

export default TeamsAPI;
